var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"tooltip-box"},[_vm._t("default"),_c('div',{staticClass:"tooltip"},[_c('span',{staticClass:"text"},[_vm._v(_vm._s(_vm.text))])])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }